import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import { Text } from 'library';

export default function AccountMenuItem({
    icon,
    action,
    text,
    id,
}: {
    icon: React.ReactNode;
    action: () => void;
    text: string;
    id?: string;
}) {
    return (
        <MenuItem onClick={action} disableRipple id={id}>
            {icon}
            <Text variant="body1" bold textStyle={{ marginLeft: 8 }}>
                {text}
            </Text>
        </MenuItem>
    );
}
